// Generated from generation-rejection-register.json; checked by check:server.
export const GENERATION_REJECTION_CODES = [
  'RISU_BOUNDED_REGEX',
  'RISU_PARSER_BUDGET_EXCEEDED',
  'aborted',
  'active_writer_stale',
  'agent_preset_generation_failed',
  'backup_copy_batch_limit_exceeded',
  'backup_copy_pool_busy',
  'backup_copy_pool_closed',
  'backup_directory_depth_exceeded',
  'bardwiki_reconcile_authority_invalid',
  'cancel_finalization_journal_unconfirmed',
  'chat_generation_settings_incomplete',
  'chat_not_found',
  'chat_occupancy_normalization_required',
  'chat_occupancy_protocol_required',
  'chat_occupancy_recovery_blocked',
  'chat_occupancy_stale',
  'chat_occupancy_switch_required',
  'chat_occupied',
  'chat_only_interaction_unsupported',
  'database_lineage_conflict',
  'finalization_journal_unconfirmed',
  'finalization_record_missing',
  'generation_aborted',
  'generation_cancel_persistence_failed',
  'generation_configuration_asset_index_invalid',
  'generation_configuration_chat_missing',
  'generation_configuration_dependency_corrupt',
  'generation_configuration_dependency_cycle',
  'generation_configuration_dependency_invalid',
  'generation_configuration_dependency_missing',
  'generation_configuration_invalid',
  'generation_configuration_version_unsupported',
  'generation_credential_authority_missing',
  'generation_credential_identity_changed',
  'generation_credential_unavailable',
  'generation_effect_atomic_commit_required',
  'generation_effect_claim_stale',
  'generation_effect_foreign_session',
  'generation_effect_target_stale',
  'generation_effective_configuration_too_large',
  'generation_effects_not_found',
  'generation_ended_without_result',
  'generation_finalization_lineage_stale',
  'generation_finalization_pending',
  'generation_in_progress',
  'generation_job_configuration_missing',
  'generation_job_configuration_stale',
  'generation_job_foreign_session',
  'generation_job_lineage_missing',
  'generation_job_lineage_stale',
  'generation_job_not_found',
  'generation_job_start_failed',
  'generation_job_target_stale',
  'generation_operation_foreign_session',
  'generation_operation_lineage_missing',
  'generation_operation_lineage_stale',
  'generation_operation_not_found',
  'generation_persistence_failed',
  'generation_scope_invalid',
  'generation_settings_not_ready',
  'generation_terminal_snapshot_not_found',
  'hypa_context_truncation_confirmation_required',
  'invalid_maintenance_lease',
  'legacy_recovery_unavailable',
  'malformed_finalization_journal',
  'message_id_conflict',
  'mutation_id_conflict',
  'not_applicable',
  'not_configured',
  'operation_effective_configuration_invalid',
  'operation_effective_configuration_missing',
  'operation_id_conflict',
  'operation_intent_missing',
  'operation_not_retryable',
  'operation_state_conflict',
  'operation_target_stale',
  'provider_dispatch_exception',
  'provider_failed',
  'provider_output_banned',
  'retry_request_id_conflict',
  'revision_conflict',
  'server_restarted',
  'stale_generation_attempt',
  'startup_failed',
  'unknown_stop',
  'user_stop',
] as const
export type GenerationRejectionCode = (typeof GENERATION_REJECTION_CODES)[number]
